export default __webpack_public_path__ + "static/media/mobilelogo.74f599d6.svg";